export enum DocumentTypes {
  cutSheet = 'cutSheet',
  equipmentSchedule = 'equipmentSchedule',
  revit = 'revit',
  revit200 = 'revit200',
  revit300 = 'revit300',
}
